import {
  BooleanFlags,
  FlagType,
  LaunchDarklyFlag,
  NumericFlags,
  StringFlags,
  VariationFlags,
} from './flags';
import { useFlagCore } from './platform-client';
import safeFlagDefaults from './safe-flag-defaults';

export { LaunchDarklyFlag };

export function useFlag<T>(flag: VariationFlags): T | null | undefined;
export function useFlag(flag: NumericFlags): FlagType<NumericFlags>;
export function useFlag(flag: StringFlags): FlagType<StringFlags> | undefined;
export function useFlag(flag: BooleanFlags): FlagType<BooleanFlags>;
export function useFlag(flag: LaunchDarklyFlag): FlagType<LaunchDarklyFlag> {
  return useFlagCore(flag, safeFlagDefaults[flag]);
}
